var shixiOffers=[
    {
        name: "机器人软件系统集成工程师",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "参与 Linux/Android/Windows 平台下的智能设备/机器人的研发。",
            "软件系统设计、移植和调试。",
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉 C/C++ 或 C#，熟悉 Linux/window 系统的进程、线程开发，熟悉计算机体系架构或面向对象的编程，了解 python /MATLAB 的使用。 ",
            "熟练掌握 Qt/PyQt 等 UI 设计。",
            "具备图像处理知识和嵌入式平台开发经验者优先。",
        ]
    },
    {
        name: "机器人软件工程师",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "机器人底层控制系统软件架构设计开发。",
            "机器人内部各功能模块嵌入式软件开发。",
            "传感器选型及嵌入式驱动编写、上位机驱动程序编写。",
            "机器人功能方案制定与实现。"
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟练使用 C/C++，熟悉 Python，具备良好的编码习惯与文档规范。",
            "熟悉 Linux， UCOSIII、FreeRTOS 等至少一种嵌入式实时操作系统。",
            "熟悉 ROS 机器人操作系统者优先，Robocon、Robomasters、电子设计大赛、飞思卡尔智能车等机器人竞赛获奖者优先。",
        ]
    },
    {
        name: "机器人算法工程师（SLAM）",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责机器人基于激光雷达、摄像头、IMU 等传感器的二/三维 SLAM 算法的应用。",
            "负责机器人在室内未知环境中的 SLAM 算法研发。",
            "负责总体运作系统设计工作，运用已有的算法完成系统构建和应用层的硬件通讯。",
            "负责 SLAM 导航系统的集成、调试、修改、测试和优化工作。"
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉SLAM、导航、路径规划、控制及目标识别技术。",
            "进行过相关运动控制器、驱动器或嵌入式系统开发经验者优先。 ",
            "Kaggle、Robocon、RoboMaster、恩智浦杯智能车竞赛等赛事获奖者优先 。",
        ]
    },
    {
        name: "机器人算法工程师（导航）",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "使用多源传感器开发基于不同依据的高精度定位模块，用于自动驾驶高精度定位。",
            "使用视觉和 Lidar 技术建立定位模块使用的高精度地图。",
            "综合使用相关知识，完成大规模自动化的多源传感器标定。",
            "负责自动驾驶车多传感器融合定位算法的研发，和导航决策与路径规划工作。"
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "了解常用 vSLAM，VO/VIO 或 LiDAR SLAM 算法。",
            "熟悉 GPS 卫星定位原理，具有融合 GPS、IMU 及里程计等多种设备的定位算法研发经验，掌握多传感器数据融合、姿态解算及惯性导航。",
            "熟悉 Kalman、粒子滤波等常用融合算法，熟悉自动驾驶汽车相关路径规划与决策。",
            "Kaggle、Robocon、RoboMaster、恩智浦杯智能车竞赛等赛事获奖者优先 。"
        ]
    },
    {
        name: "机器人硬件工程师",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "根据公司机器人产品需求规划设计硬件方案。",
            "根据硬件方案，进行传感器、处理器等关键器件选型。",
            "根据硬件方案进行 PCB 设计、BOM 表生成及成本功能评估，并完成 PCB 生产流程。",
            "负责 PCB 打样焊接及测试。",
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉基于 ARM 平台的 STM32 系列硬件的开发。",
            "熟悉基本逻辑电路、运放、有刷/无刷电机驱动、稳压电路等硬件选型及设计。",
            "熟悉常用 IIC、CAN、SPI、USART、RS232/485 等通信协议。",
            "具有以下经验者优先：多层 PCB 板实际开发，具备 IMU、电压电流检测、TOF 距离测量等传感器硬件设计，参加过机器人竞赛并获奖。 "
        ]
    },
    {
        name: "嵌入式测试工程师",
        address: [1, 2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责终端平台、软件测试工作。",
            "完成测试流程、测试计划、测试方案的制定、实施和跟踪。",
            "负责相关测试文档记录。",
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉精通终端系统黑盒和白盒测试。",
            "熟悉硬件设计，能够独立查看原理图。",
            "熟悉ARM平台裸机和Linux操作系统软件测试，熟悉Shell脚本编程，熟悉Android者优先。"
        ]
    },
    {
        name: "嵌入式软件工程师（Android系统开发）",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责 Android 底层和 HAL 层优化和开发。",
            "负责 Android Native Framework层的优化和开发。",
            "负责 Android App Framework层的优化和开发。",
            "负责 Android 整机（含 Linux Kernel）系统移植、裁减，性能调优，故障分析、定位。",
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉主流嵌入式处理器平台，有相关Android BSP 移植，Kernel 和 Driver 开发经验。",
            "熟练掌握 C/C++，数据结构，算法及 Linux Kernel 相关知识。",
            "熟悉 Android Framework，Graphic 原理。",
            "有内存优化，功耗优化，系统性能优化方面经验。"
        ]
    },
    {
        name: "嵌入式软件工程师（Linux系统开发）",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责嵌入式平台Linux系统各个组件的定制、裁剪。",
            "配合驱动开发工程师、硬件工程师，进行硬件调试。",
            "配合应用开发工程师，进行软件移植调试。",
            "负责编写Linux系统开发文档，维护各个嵌入式平台Linux系统源码。",
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉Linux系统启动流程，熟悉uboot/kernel/devicetree/filesyste等移植流程。",
            "有良好的硬件基础，熟悉各种硬件接口，能够根据原理图进行板卡调试。",
            "熟悉yocto/petelinux/buildroot等linux系统定制工具。",
            "熟悉软件移植，熟悉cmake/configure/make等软件移植工具。"
        ]
    },
    {
        name: "嵌入式软件工程师（应用）",
        address: [1, 2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责嵌入式平台的软件设计、开发、测试工作。",
            "与硬件、测试及其他软件团队沟通，配合软硬件测试。",
            "参与编写、维护开发文档，设计测试用例。",
        ],
        describe: [

            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉嵌入式平台裸机、操作系统（Linux、uCOS等）软件开发流程、开发环境。",
            "有良好的硬件基础，熟悉各种硬件接口，能够根据原理图进行板卡调试。",
            "熟悉C/C++语言，扎实的计算机软件基础（数据结构、算法、操作系统、数据库原理等）。",
            "熟悉常用外设接口（uart/i2c/usb）通信、网络编程。",
            "熟悉线程间通信、了解进程间通信。",
            "有以下音视频开发经验者优先，熟悉音视频原始格式（RGB/YUV/PCM等），熟悉常用音视频压缩格式(MJPG/H.264等)，熟悉gstreamer视频架构。",
            "熟悉QT编程，有QT程序开发经验者优先。",
            "熟悉软件移植，熟悉cmake/configure/make等软件移植工具。"
        ]
    },
    {
        name: "驱动开发工程师",
        address: [1,2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责智能处理器平台的系统软件研发。",
            "独立开发Linux系统驱动程序。",
            "负责优化系统性能和可靠性。",
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟练掌握C/ C++编程技能。",
            "熟悉ARM/X86系统架构和Linux内核，熟悉Linux系统接口和驱动的开发、熟悉Camera/LCD等视频前后端接口、熟悉PCIE/I2C/SPI等总线接口熟悉ARM平台SMMU架构和驱动。",
            "有SoC平台IP驱动和系统软件开发经验者优先。",
        ]
    },
    {
        name: "硬件工程师（初级）",
        address: [1, 2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责公司产品的硬件BOM文件整理、核对和维护，PCBA信号测试。",
            "负责公司产品硬件生产资料的编撰，下发，生产异常解析。",
            "配合软件工程师进行相关的测试验证。",
            "负责撰写产品维修手册和使用说明。",
        ],
        describe: [
            "计算机、通信工程、电子工程、自动化等相关专业，全日制本科及以上学历。",
            "熟悉模电、数电、射频电路等相关基本原理知识，熟练掌握电子元器件特性。",
            "熟练使用Cadence、AD或PADS其中一种画图软件。",
            "了解PCB制造和SMT生产相关知识。"
        ]
    },
    {
        name: "软件工程师（Android应用开发）",
        address: [1, 2],
        kind1: 1,
        money: "面议",
        skills: [
            "独立完成编码，参与独立模块与组件库的开发。",
            "负责手机客户端产品的开发及优化。",
        ],
        describe: [
            "计算机、软件等相关专业，全日制本科及以上学历。",
            "熟练Android的线程机制，网络编程、通信协议、UI框架。",
            "熟悉Android 开发平台架构和原理 熟悉系统核心机制，包括 SystemServer 启动过程、AMS、WMS、Binder 机制等。",
            "接入过多个平台SDK，对Android机型以及适配方面有丰富经验。",
            "有JNI开发经验或熟悉JNI者优先。"
        ]
    },
    {
        name: "软件工程师（后端）",
        address: [1, 2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责服务端代码编写。",
            "负责基础通信相关服务的设计与开发。",
            "负责 API 设计文档的撰写。",
        ],
        describe: [
            "计算机、软件等相关专业，全日制本科及以上学历。",
            "熟悉数据结构、计算机原理",
            "了解常用网络协议，如socket、http等",
            "有扎实的 Java 基础，了解JKD1.8；",
            "熟悉 Spring、SpringMVC、Hibernate、MyBatis等框架。",
            "熟练使用常用数据存储组件，比如mysql、oracle、redis等。",
            "具备项目开发经验者优先。"
        ]
    },
    {
        name: "软件工程师（前端）",
        address: [1, 2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责公司产品的Web前端开发/维护工作。",
            "独立负责项目的开发、调试、修改工作。",
            "负责与设计、后台开发人员等保持良好沟通，快速理解、消化各方需求，并落实为具体的开发工作。",
        ],
        describe: [
            "计算机、软件等相关专业，全日制本科及以上学历。",
            "熟悉数据结构、计算机原理",
            "了解常用网络协议，如socket、http等",
            "熟悉前端基础技能，熟练使用HTML5、CSS3、JavaScript(ES6)等前端技术。",
            "熟练使用jquery，熟悉Vue、React等前端主流框架。",
            "熟练使用 Chrome 的开发者工具。",
            "熟悉node.js者优先。",
            "具备项目开发经验者优先。"
        ]
    },
    {
        name: "算法工程师（CV/机器学习）",
        address: [1, 2],
        kind1: 1,
        money: "面议",
        skills: [
            "负责图像/视频相关算法的研究与开发。包括：目标检测、像分类、图像分割、目标跟踪、视频语义分析、人脸识别与分析、车辆与行人的检测识别跟踪、OCR 算法、视频结构化算法等。 ",
            "负责图像理解、机器学习、深度学习等前沿技术的研发，结合实际应用场景，提供技术解决方案。",
        ],
        describe: [
            "计算机、模式识别、机器学习、自然语言处理等相关研究方向，硕士及以上学历。",
            "熟练掌握计算机视觉和图像处理相关基本算法。",
            "较强的算法实现能力，至少精通 C/C++/Python/Matlab 等编程语言中的一种。",
            "在顶级会议/期刊上发表过论文，相关国际比赛获奖，及持有相关专利者优先。",
        ]
    },           
];

export default shixiOffers


// WEBPACK FOOTER //
// ./src/store/shixiOffers.js